import React from "react";
import Footer from "./Footer";
import { CircleX } from "lucide-react";
import SafeHTML from "../../../components/SafeHTML";

const InvalidToken = ({ uiConfig = {} }) => {
  // Safe access
  const global = uiConfig?.Global || {};
  const invalidToken = uiConfig?.InvalidToken || {};
  const cardBgColor = global?.card?.backgroundColor || "#f3f4f6"; // gray-100
  const cardOpacity = global?.card?.opacity || "1"; // default opacity
  const pageBgColor = global?.pageContainer?.backgroundColor || "#ffffff"; // white
  const textColor = global?.text?.fontColor || "#6b7280"; // default gray-500
  const showFooter = global?.Footer?.Show !== undefined ? global.Footer.Show : true;

  const getTitleHTML = () => {
    const titleConfig = invalidToken?.Title?.Text;
    if (titleConfig) {
      return titleConfig;
    }
    return `<p style="font-size: 1.5rem; font-weight: 500; line-height: 2rem; color: ${textColor};">
      Invalid or expired session
    </p>`;
  };

  const getDescriptionHTML = () => {
    const descriptionConfig = invalidToken?.Description?.Text;
    if (descriptionConfig) {
      return descriptionConfig;
    }
    return `<p style="font-size: 1rem; margin-top: 1rem; color: ${textColor};">
      Your session is invalid or has expired. Please start the process again.
    </p>`;
  };
  return (
    <div
      style={{
        background: pageBgColor,
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        padding: "1rem",
        height: "100%",
      }}
    >
      <div
        style={{
          background: cardBgColor,
          opacity: cardOpacity,
          padding: "2rem",
          borderRadius: "1rem",
          marginTop: "calc(100vh / 16)",
          marginBottom: "2rem",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <SafeHTML html={getTitleHTML()} />
          <SafeHTML html={getDescriptionHTML()} />
        </div>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "2rem" }}>
          <CircleX height="72" width="72" color="red" />
        </div>
      </div>

      <div style={{ flex: 1 }} />

      {showFooter && (
        <Footer
          style={{
            fontSize: "0.75rem",
            color: textColor,
            marginTop: "1rem",
          }}
        />
      )}
    </div>
  );
};

export default InvalidToken;
